/**
 *
 *	🚨🚨🚨 THIS FILE IS AUTOGENERATED 🚨🚨🚨
 *	TO MAKE CHANGES - PLEASE EDIT "./src/templates/components/Icon.tsx.ejs"
 *
 */

import React, { FC } from "react";
import cx from "clsx";
import { IconProps } from "../types";

const IconsList = [
	"add",
	"alert--o",
	"alert",
	"arrow-double",
	"arrow-left",
	"arrow-right",
	"arrow-thick-down",
	"arrow-thick-right",
	"arrow-thick-up",
	"calendar-alt",
	"calendar",
	"check",
	"checked",
	"checkmark",
	"close--n",
	"close",
	"complaints",
	"cruise-alt",
	"cruise",
	"customer-assistance",
	"email--o",
	"europe",
	"external",
	"facebook",
	"faq",
	"favorite",
	"filters",
	"flight",
	"flights",
	"globe",
	"hotel",
	"inclusive",
	"information",
	"instagram",
	"lastmin",
	"map",
	"menu",
	"minus--n",
	"parking",
	"phone",
	"pinterest",
	"plus--n",
	"refresh--o",
	"review",
	"search",
	"star-half",
	"star",
	"timer",
	"travel",
	"twitter",
	"uplift",
	"video",
	"youtube",
] as const;

const Icon: FC<
	IconProps & {
		name: typeof IconsList[number];
	}
> = ({
	iconPrefix = "sov-icon",
	name,
	className,
	title,
	hidden,
	fixedWidth,
	rotate,
	size,
	animate,
}) => (
	<span
		className={cx(iconPrefix, `${iconPrefix}-${name}`, className, {
			[`${iconPrefix}--${size}`]: size,
			[`${iconPrefix}--fw`]: fixedWidth,
			[`${iconPrefix}--r-${rotate}`]: rotate,
			[`${iconPrefix}--${animate}`]: animate,
		})}
		aria-label={title}
		aria-hidden={hidden}
	/>
);

Icon.displayName = "Icon";

export default Icon;
export { Icon };
